import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { setActiveProfileId } from '@/state/global/creators';
import BuyerRouting from '@/buyer/BuyerRouting';
import { IState } from '@/state/IState';
import ClientStorage from '@/ClientStorage';
import { ProfileType } from '@/types';
import SessionStorage from '@/SessionStorage';
import NoProfilesMessage from '@/components/profile/NoProfilesMessage';
import SellerRouting from '@/seller/SellerRouting';
import { useAppDispatch } from '@/utils/hooks';

interface ProfileRoutingProps {}

const ProfileRouting: React.FC<ProfileRoutingProps> = () => {
    const dispatch = useAppDispatch();
    const activeProfile = useSelector((state: IState) => state.global.activeProfile);
    const profiles = useSelector((state: IState) => state.global.profiles);

    useEffect(() => {
        if (!profiles) {
            return;
        }

        if (activeProfile) {
            ClientStorage.lastProfileId = activeProfile.id;
            return;
        }

        // if (profiles.length === 0) {
        //     history.push('/profiles/new');
        //     return;
        // }

        if (profiles[0]) {
            // ClientStorage.lastProfileId = profiles[0].profileId;
            setActiveProfileId(dispatch, profiles[0].profileId);
        }
    }, [profiles, activeProfile, dispatch]);

    if (profiles && profiles.length === 0) {
        return <NoProfilesMessage />;
    }

    if (!activeProfile) {
        return <LoadingIndicator />;
    }

    //Fixes redirect after changing profile
    //TODO: find better solution instead of this workaround
    // if (!activeProfile || activeProfile.id !== +match.params.profileId) {
    //     return <LoadingIndicator />;
    // }

    // if (location.state && location.state.impersonationResidentialUnitId) {
    //     return <BuyerRouting key={activeProfile.id} residentialUnitId={+location.state.impersonationResidentialUnitId} />;
    // }

    if (SessionStorage.impersonationResidentialUnitId) {
        return <BuyerRouting key={activeProfile.id} residentialUnitId={SessionStorage.impersonationResidentialUnitId} />;
    }

    switch (activeProfile.type) {
        case ProfileType.Buyer:
            return <BuyerRouting key={activeProfile.id} />;

        case ProfileType.Seller:
            return <SellerRouting key={activeProfile.id} />;

        default:
            return null;
    }
};

export default ProfileRouting;
